import React, { useState, useEffect } from "react";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import { SocialIcon } from "react-social-icons";

const api = {
  key: "3c99c5836c8c316d65347ae5ab3171fc",
  baseURL: "https://api.openweathermap.org/data/2.5/",
};

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function About() {
  const [author, setAuthor] = useState(null);
  const [weather, setWeather] = useState({});

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "author"] {
      name,
      "authorImage": image.asset->url
    }`
      )
      .then((data) => setAuthor(data[0]))
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetch(`${api.baseURL}weather?q=Melbourne,AU&units=metric&APPID=${api.key}`)
      .then((res) => res.json())
      .then((result) => setWeather(result))
      .catch(console.error);
  }, []);

  console.log(weather);

  if (!author) {
    return (
      <div className="flex justify-center p-40 loading-text">Loading...</div>
    );
  }

  const generateDate = (d) => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    let day = days[d.getDay()];
    let date = d.getDate();
    let month = months[d.getMonth()];
    let year = d.getFullYear();

    return `${day} ${date} ${month} ${year}`;
  };

  return (
    <main>
      <div className="about-container">
        <div className="personal-info">
          <div>
            <div className="about-namecard">
              <img src={urlFor(author.authorImage).url()} alt={author.name} />
              <h1>Zelin Shu</h1>
              <div>
                <SocialIcon
                  url="https://github.com/PotatoPlan"
                  target="_blank"
                  bgColor="#00000"
                  style={{
                    height: 30,
                    width: 30,
                    position: "absolute",
                    left: 170,
                    top: 95,
                  }}
                />
              </div>

              <a href="https://github.com/PotatoPlan" target="blank">
                <h2
                  style={{
                    position: "absolute",
                    left: 207,
                    top: 96,
                    fontSize: 20,
                  }}
                >
                  PotatoPlan
                </h2>
              </a>
            </div>

            {/* MARK */}
            <div className="about-education">
              <h1 style={{ fontWeight: "bold" }}>EDUCATION</h1>
              <p style={{ fontWeight: "bold" }}>Monash University</p>
              <p>Master of Information Technology (2020 - 2021)</p>
              <p style={{ fontWeight: "bold", marginTop: 5 }}>
                Monash University
              </p>
              <p>Bachelor of Business (2017 - 2019)</p>
            </div>

            <div className="about-skillsets">
              <h1 style={{ fontWeight: "bold" }}>SKILLSETS</h1>
              <div className="about-skill-icons">
                <i class="devicon-javascript-plain"></i>
                <i class="devicon-html5-plain"></i>
                <i class="devicon-css3-plain"></i>
                <i class="devicon-react-original"></i>
                <i class="devicon-csharp-plain"></i>
                <i class="devicon-dot-net-plain"></i>
                <i class="devicon-java-plain"></i>
                <i class="devicon-android-plain"></i>
                <i class="devicon-python-plain"></i>
                <i class="devicon-amazonwebservices-original"></i>
                <i class="devicon-firebase-plain"></i>
                <i class="devicon-git-plain"></i>
                <i class="devicon-figma-plain"></i>
                <i class="devicon-r-plain"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="about-weather-container">
          {typeof weather.main != "undefined" ? (
            <div>
              <div className="weather-info">
                <p style={{ fontSize: 20 }}>{generateDate(new Date())}</p>
                Currently in {weather.name}, {weather.sys.country}
                <p style={{ fontSize: 120 }}>
                  {Math.round(weather.main.temp)} °C
                </p>
                <p>{weather.weather[0].main}</p>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </main>
  );
}
